import RankingPreview from '../../QuestionPreviews/RankingPreview/RankingPreview';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { rankingIcons } from '../../../../constants/rankingIcons';
import { useDispatch } from 'react-redux';
import {
  addQuestionOption,
  removeQuestionOption,
  updateQuestionOption,
  updateQuestion
} from '../../../../../../../store/actions/dataEntryTemplateGeneratorActions';
import { Select, MenuItem, Box, Grid, TextField, IconButton } from '@mui/material';
import { useState, useRef } from 'react';
import './RankingQuestion.css';

const RankingQuestion = ({ question, onChangeAlert }) => {
  const { isActive, config = {}, options: questionOptions } = question;
  const { color: iconColor, icon } = config;
  const [selectedIcon, setSelectedIcon] = useState(icon || rankingIcons[0].value);
  const [color, setColor] = useState(iconColor || '#FFC107');
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const onClickColorBox = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleChangeOption = (event, optionId) => {
    const payload = {
      questionId: question.id,
      optionId,
      option: { [event.target.name]: event.target.value }
    };

    dispatch(updateQuestionOption(payload));
    onChangeAlert();
  };

  const handleRemoveOption = (option) => {
    dispatch(removeQuestionOption({ questionId: question.id, optionId: option?.id }));
    onChangeAlert();
  };

  const handleAddOption = () => {
    const payload = {
      questionId: question.id,
      option: {
        id: new Date().getTime(),
        value: '',
        option: '',
        order: questionOptions.length + 1,
        error: {}
      }
    };

    dispatch(addQuestionOption(payload));
    onChangeAlert();
  };

  const handleOnchangeConfig = (event) => {
    event.preventDefault();
    const payload = {
      id: question.id,
      config: { ...config, [event.target.name]: event.target.value }
    };

    if (event.target.name === 'icon') {
      const filteredIcon = rankingIcons.find((icon) => icon.value === event.target.value);
      payload.config.iconInfo = [`${filteredIcon?.type}`, `${filteredIcon?.value}`];
      setSelectedIcon(event.target.value);
    } else if (event.target.name === 'color') {
      setColor(event.target.value);
    }

    dispatch(updateQuestion(payload));
    onChangeAlert();
  };

  const filteredIcon = rankingIcons.find((icon) => icon.value === selectedIcon);

  return (
    <>
      {!isActive ? (
        <RankingPreview question={question} />
      ) : (
        <>
          <Box className='ranking-icons__container'>
            <Box className='ranking-icons__icon-section'>
              <span>Icon</span>
              <Select
                value={selectedIcon}
                onChange={handleOnchangeConfig}
                displayEmpty
                name='icon'
                variant='standard'
              >
                {rankingIcons.map((icon) => (
                  <MenuItem key={icon.value} value={icon.value}>
                    {icon.icon}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box className='ranking-icons__icon-section'>
              <span>Color</span>
              <div
                className='ranking-color__picker'
                style={{ backgroundColor: color }}
                onClick={onClickColorBox}
              >
                <input
                  ref={inputRef}
                  style={{ visibility: 'hidden' }}
                  type='color'
                  id='icon-color'
                  name='color'
                  value={color}
                  onChange={handleOnchangeConfig}
                />
              </div>
            </Box>
          </Box>
          <Box className='ranking-options'>
            {questionOptions.map((option, index) => (
              <Grid className='ranking-options__grid' key={index} container>
                <Grid className='ranking-options__value-container' item xs={3}>
                  {filteredIcon?.icon ? (
                    <>
                      <div
                        style={{
                          with: '20px',
                          height: '20px',
                          marginRight: '10px'
                        }}
                      >
                        {filteredIcon?.icon}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <TextField
                    label='Value'
                    name='value'
                    type='number'
                    value={option?.value}
                    error={option?.error?.value && option?.error?.value !== '' ? true : false}
                    helperText={option?.error?.value}
                    onChange={(event) => handleChangeOption(event, option?.id)}
                    style={{ mr: 1, width: '100%' }}
                    className='custom-text-field'
                    variant='standard'
                  />
                </Grid>

                <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    label='Option'
                    name='option'
                    value={option?.option}
                    error={option?.error?.option && option?.error?.option !== '' ? true : false}
                    helperText={option?.error?.option}
                    onChange={(event) => handleChangeOption(event, option?.id)}
                    style={{ mr: 1, flex: 1, width: '100%' }}
                    className='custom-text-field'
                    variant='standard'
                  />
                </Grid>

                <Grid className='ranking-options__action' item xs={1}>
                  {questionOptions.length > 1 && (
                    <IconButton
                      onClick={() => handleRemoveOption(option)}
                      className='ranking-options__action-button'
                    >
                      <FontAwesomeIcon
                        icon='circle-minus'
                        className='ranking-options__action-button__icon '
                      />
                    </IconButton>
                  )}
                  {(config?.maxOptions === -1 || questionOptions.length < config?.maxOptions) && (
                    <IconButton onClick={handleAddOption} className='ranking-options__action-button'>
                      <FontAwesomeIcon icon='plus' className='ranking-options__action-button__icon ' />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          </Box>
        </>
      )}
    </>
  );
};

export default RankingQuestion;
